module.exports = __webpack_public_path__ + "videos/15.a36c0b2.mp4";